'use strict';

window.addEventListener('hashchange', () => {
  if (window.location.hash === '#menu') {
    document.body.classList.add('page--with-menu');
  } else {
    document.body.classList.remove('page--with-menu');
  }
});

document.addEventListener('submit', (e) => {
  e.preventDefault();
  e.target.reset();
});
